export default __webpack_public_path__ + "4e83cba1f48bfc08fbbefadd420f9be9.png";